// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3f-1";
export var rateTableServiceLevelDropdown = "_3f-3";
export var rateTableTypeDropdown = "_3f-0";
export var rateTableValueModeDropdown = "_3f-2";